import { ofType } from 'redux-observable';
import { EMPTY, merge, of } from 'rxjs';
import { map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { addonQuotePriceInconsistent, addonQuoteRemoved } from 'state/addonForm/addonForm.action';
import * as actionTypes from 'state/addonForm/addonForm.actionTypes';
import { getInfo } from 'state/addonForm/addonForm.selector';
import type { EpicWithThunk } from 'state/state.common';

export function onAddonFormChangedEpic(): EpicWithThunk {
  return (action$, state$, { selectors: { addonSelector } }) => {
    const formDataChangedTabId$ = action$.pipe(
      ofType(
        actionTypes.ADDON_NOTIONAL_CHANGED,
        actionTypes.ADDON_NOTIONAL_TYPE_CHANGED,
        actionTypes.ADDON_CLIENT_CHANGED,
        actionTypes.ADDON_DEAL_SPLIT_CHANGED,
        actionTypes.ADDON_TRADE_CLIENT_SIDE_CHANGED,
        actionTypes.ADDON_MERGE_DEALS_REQUESTED_CHANGED,
        actionTypes.ADDON_SELECTED_TRADE_REFERENCE_CHANGED,
        actionTypes.ADDON_REMUNERATION_MODE_CHANGED,
        actionTypes.ADDON_SOLVE_MODE_CHANGED,
        actionTypes.ADDON_X_MARGIN_CHANGED,
        actionTypes.ADDON_UPFRONT_FEE_CHANGED,
        actionTypes.ADDON_OFFER_PRICE_CHANGED,
      ),
      map(action => action.tabId),
    );

    const quoteCancelledTabId$ = action$.pipe(
      ofType(actionTypes.ADDON_QUOTE_CANCELLED),
      map(action => action.tabId),
    );

    return merge(formDataChangedTabId$, quoteCancelledTabId$).pipe(
      withLatestFrom(state$),
      mergeMap(([tabId, state]) => {
        const quoteId = addonSelector.getLastQuoteId(state, tabId);
        const info = getInfo(state, tabId);
        if (quoteId) {
          if (info?.quoteState !== 'Previous') {
            return of(addonQuoteRemoved(tabId, quoteId));
          } else {
            return of(addonQuotePriceInconsistent(tabId));
          }
        }
        return EMPTY;
      }),
    );
  };
}
